'use strict';

function DoAssignationController(
  $scope,
  $mdDialog,
  WorkersService,
  assignationsCount: number,
  suggestedDate: Date,
  suggestedWorker: any,
  allAssignationsCount: number
) {
  $scope.assignationsCount = assignationsCount;
  $scope.date = suggestedDate;
  $scope.worker = suggestedWorker;
  $scope.remaining = assignationsCount < allAssignationsCount ?
    `(restan en el listado: ${allAssignationsCount - assignationsCount})` : '';

  $scope.save = function() {
    $mdDialog.hide({
      date: $scope.date,
      worker: $scope.worker
    });
  };

  $scope.queryWorkerSearch = function(text: string) {
    return WorkersService.find({
      filter: {
        where: {
          name: {
            ilike: `%${text}%`
          }
        }
      }
    });
  };

  $scope.cancel = function() {
    $mdDialog.cancel();
  };
}
DoAssignationController.$inject = [
  '$scope',
  '$mdDialog',
  'WorkersService',
  'assignationsCount',
  'suggestedDate',
  'suggestedWorker',
  'allAssignationsCount'
];

export default DoAssignationController;
